import dayjs, { Dayjs } from "dayjs";

import { buildThisMonthCashflow } from "@/logics/thisMonthCashflow";
import type { MonthlyBalanceSheet } from "@/view_models/balancesheetTypes";

export const calculateCashflowAverage = (
  monthlySheets: ReadonlyMap<string, Pick<MonthlyBalanceSheet, "result">>,
  propertyCategory: string | undefined,
  boughtAt: string | null | undefined,
  today: Dayjs = dayjs()
): { average: number | null; monthCount: number } => {
  const purchase = boughtAt ? dayjs(boughtAt) : null;
  if (!purchase?.isValid() || purchase.isAfter(today, "day")) return { average: null, monthCount: 0 };
  const currentMonth = today.startOf("month");
  const firstMonth = currentMonth.subtract(11, "month");
  const purchaseMonth = purchase.startOf("month");
  const start = purchaseMonth.isAfter(firstMonth) ? purchaseMonth : firstMonth;
  const monthCount = currentMonth.diff(start, "month") + 1;
  let total = 0;
  for (let index = 0; index < monthCount; index++) {
    const sheet = monthlySheets.get(start.add(index, "month").format("YYYY/MM"));
    // A partial data set must not be presented as a complete average.
    if (!sheet) return { average: null, monthCount };
    total += buildThisMonthCashflow(propertyCategory, sheet.result).totalCashFlow;
  }
  return { average: Math.round(total / monthCount), monthCount };
};
